const isBrowser = () => typeof window !== "undefined";

const stopBrowserBack = (callback: () => void) => {
  window.history.pushState(null, "", window.location.href);
  window.onpopstate = () => {
    window.history.pushState(null, "", window.location.href);
    callback();
  };
};

const enableBrowserBack = () => {
  window.onpopstate = null;
};

const browserUtils = {
  isBrowser,
  stopBrowserBack,
  enableBrowserBack,
};

export default browserUtils;
